export const SvgFlames = () => {
	return (
		<svg
			width="14"
			height="20"
			viewBox="0 0 14 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.39367 19.5081C4.03921 20.3596 -6.99214 13.4698 6.4777 0C6.4777 0 6.24541 6.42438 9.03233 10.683C9.03233 10.683 9.26462 8.3993 11.8192 5.65112C11.8191 5.65112 18.5361 17.5246 8.39367 19.5081Z"
				fill="#FA4B4B"
			/>
		</svg>
	);
};
